import axios from '@/libs/axios'

export default {
  getPartners: params => axios.get('/external-partners', { params }),
  getPartnerById: id => axios.get(`/external-partners/${id}`),
  createPartner: payload => axios.post('/external-partners', payload),
  updatePartner: (id, payload) => axios.patch(`/external-partners/${id}`, payload),
  deletePartner: id => axios.delete(`/external-partners/${id}`),

  getPartnerUsers: (partnerId, params) => axios.get(`/external-partners/${partnerId}/users`, { params }),
  getAssignableUsers: params => axios.get('/external-partners/users/lookup', { params }),
  assignUserToPartner: (partnerId, payload) => axios.post(`/external-partners/${partnerId}/users`, payload),
  unassignUserFromPartner: (partnerId, userId) => axios.delete(`/external-partners/${partnerId}/users/${userId}`),

  getPartnerCustomerMappings: (partnerId, params) => axios.get(`/external-partners/${partnerId}/customer-mappings`, { params }),
  getCustomersLookup: params => axios.get('/external-partners/customers/lookup', { params }),
  createPartnerCustomerMapping: (partnerId, payload) => axios.post(`/external-partners/${partnerId}/customer-mappings`, payload),
  updatePartnerCustomerMapping: (partnerId, mappingId, payload) => axios.patch(`/external-partners/${partnerId}/customer-mappings/${mappingId}`, payload),
  deletePartnerCustomerMapping: (partnerId, mappingId) => axios.delete(`/external-partners/${partnerId}/customer-mappings/${mappingId}`),
}
